import React, { useEffect, useState } from 'react';
import BASE_URL from '../config'; // Import BASE_URL

const ShowKeeper = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = () => {
      fetch(`${BASE_URL}api/proxy?action=latest_keeperdata`) // Use BASE_URL
        .then(response => response.json())  // Use .json() for JSON response
        .then(json => {
          // Check if the data exists in the response
          if (json && json.data) {
            setData(json.data);  // Set the data
          } else {
            setError('No data available');
          }
        })
        .catch(err => {
          console.error('Fetch error:', err);
          setError('Failed to load data');
        });
    };

    fetchData(); // Initial fetch
    const interval = setInterval(fetchData, 5000); // Refresh every 5 seconds

    return () => clearInterval(interval); // Cleanup
  }, []);

  return (
    <div className="container mt-3">
      <h4>Latest Keeper Data</h4>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>Col1</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={item.ID}> {/* Using ID as unique key */}
                <td>{item.col1}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShowKeeper;
